import { Navigate } from 'react-router';
import { inferRouteObject } from 'react-router-typed-object';

import { or, PrivateRoute, Roles } from '@/js/libs/use-auth';

import PlacementConfigs from 'src/scenes/PlacementConfigs';
import Status from 'src/scenes/Status';

const index = true;

export const placementConfigsRouteObject = inferRouteObject({
  path: 'placement-configs',
  element: <PrivateRoute roles={or(Roles.ADMIN, Roles.HEADER_TAG)} noAccessComponent={Status.NotFound} />,
  children: [
    {
      Component: PlacementConfigs.Helmet,
      children: [
        {
          index,
          element: <Navigate to='./app-configs' replace />,
        },
        {
          path: 'app-configs',
          children: [
            { index, Component: PlacementConfigs.AppConfigsList },
            { path: 'create', Component: PlacementConfigs.AppConfigForm },
            {
              path: 'edit',
              children: [
                { index, element: <Navigate to='../' replace /> },
                { path: ':publisherId', Component: PlacementConfigs.AppConfigForm },
              ],
            },
            {
              path: ':publisherId',
              children: [
                { index, Component: PlacementConfigs.AppConfigDetails },
                {
                  path: 'ad-config',
                  children: [
                    {
                      index,
                      Component: PlacementConfigs.AdConfigForm,
                    },
                    {
                      path: ':adConfigId',
                      Component: PlacementConfigs.AdConfigForm,
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          path: 'third-party-websites',
          element: <PrivateRoute roles={Roles.ADMIN} noAccessComponent={Status.NotFound} />,
          children: [
            { index, Component: PlacementConfigs.ThirdPartyWebsitesList },
            { path: 'create', Component: PlacementConfigs.ThirdPartyTagForm },
            {
              path: 'edit',
              children: [
                { index, element: <Navigate to='../' replace /> },
                { path: ':tagId', Component: PlacementConfigs.ThirdPartyTagForm },
              ],
            },
          ],
        },
        { path: '*', element: <Navigate to='/placement-configs/app-configs' replace /> },
      ],
    },
  ],
});
